import { normalizeProviderValue } from '../shared';

const convertFilter = ({ games, gameTypes, providers, disabledProviders = [] }) => {
  const getProviderKey = provider => (provider?.apiValue ?? provider?.value ?? '').toString();
  const getProviderIdentity = provider => `${provider?.type}:${normalizeProviderValue(provider?.value)}`;

  const structuredGames = games
    .map(g => ({
      name: g.name,
      game_id: g.value,
      is_enabled: g.isActive,
      img_url: g.imgUrl,
      display_order: g.position,
      provider: normalizeProviderValue(g.provider),
      type: g.type,
    }))
    .sort((a, b) => a.display_order - b.display_order);

  const disabledProviderIds = new Set(disabledProviders.map(getProviderIdentity));

  const getProviderGames = (providerList, forceDisabled = false) =>
    providerList
      .map(p => {
        const providerValue = normalizeProviderValue(p.value);
        const providerKey = getProviderKey(p);
        const gamesByProvider = structuredGames
          .filter(g => g.provider === providerValue && g.type === p.type)
          .map(({ type, ...game }) => (forceDisabled ? { ...game, is_enabled: false } : game));

        return gamesByProvider.length > 0 ? [providerKey, gamesByProvider] : null;
      })
      .filter(Boolean);

  const gamesConfig = gameTypes.reduce((acc, gt) => {
    const gameTypeKey = gt.value.replace('-', '_');
    const activeProviders = getProviderGames(
      providers.filter(p => p.type === gt.value && !disabledProviderIds.has(getProviderIdentity(p))),
    );

    const disabledProvidersWithGames = getProviderGames(
      disabledProviders.filter(p => p.type === gt.value),
      true,
    );

    const allProviders = [...activeProviders, ...disabledProvidersWithGames];

    if (allProviders.length > 0) {
      acc[gameTypeKey] = Object.fromEntries(allProviders);
    }

    return acc;
  }, {});

  return { games_config: gamesConfig };
};

export default convertFilter;
